import { ReactElement, useState, useEffect } from "react";
import {Button,Col,Drawer,Form,Input,Row,Select,Upload,message, Spin, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { InboxOutlined } from "@ant-design/icons";
import firebase from "firebase/app";
import "firebase/storage";
import { DrawerFooter } from "../../components/GlobalStyles";
import { EDIT_CATEGORY_REQUEST, FETCH_ALL_CATEGORY_REQUEST } from "../../redux/constants";
import { getAuthState, getUserState } from "../../redux/selectors";
import { countries, clubStatus, currencies} from "../../constants";

const { Option } = Select;
const { useForm } = Form;

type Props = {
  visible: boolean;
  onClose: () => void;
  cat: any;
};

export function EditCategoryDrawer({visible, onClose, cat}: Props): ReactElement {
    const dispatch = useDispatch();
    const { currentUser } = useSelector(getAuthState);
    const { users } = useSelector(getUserState);
    const [form] = useForm();
    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [category, setCategory] = useState<any[]>([]);
    const storage = firebase.storage();
    const [choosedCategory, setChoosedCategory] = useState<any>();

    const getCategoryItems = async () => {
        const categoryList = await firebase.firestore().collection("category").where('parent', "==", 0).get();
        if(categoryList.size !== 0)
        {
            const list = categoryList.docs;
            const catList = list.map(cats => cats.data());
            setCategory(catList);
        }

        const selCategorySnapshot = await firebase.firestore().collection("category").doc(cat.key).get();
        setChoosedCategory(selCategorySnapshot.data());
        setLoading(false);
    }

    const onFinish = async (values: any) => {
        setLoading(true);
        const formValue = {
            ...values,
            currentId : cat.key
        }
        dispatch({ type: EDIT_CATEGORY_REQUEST, payload: formValue });
        dispatch({ type: FETCH_ALL_CATEGORY_REQUEST, payload: { currentUser } });
        form.resetFields();
        setLoading(false);
        onClose();
        
    };

    const onFinishFailed = (errorInfo: any) => {
        // eslint-disable-next-line no-console
        console.log("Failed:", errorInfo);
    };

    useEffect(() => {
        getCategoryItems();
    }, []);

  return (
    <Drawer
      title={t("market.edit_category")}
      width={450}
      onClose={onClose}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      {!loading && <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
            name: cat.name,
            keyword : cat.keyword,
            parent:choosedCategory?.parent
        }}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="name" label={t("market.category_name")}
              rules={[
                {
                  required: true,
                  message: t("market.category_name_placeholder"),
                },
              ]}
            >
              <Input placeholder={t("market.category_name_placeholder")} autoComplete="off"/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="keyword" label={t("market.category_keyword")}
              rules={[
                {
                  required: true,
                  message: t("market.category_keyword_placeholder"),
                },
              ]}
            >
              <Input placeholder={t("market.category_keyword_placeholder")} autoComplete="off"/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
            <Col span={24}>
                <Form.Item
                    name="parent"
                    label={t("market.parent_category")}
                >
                    <Select 
                        placeholder={t("market.parent_category_placeholder")}>
                        <Option key={0} value={0}>None</Option>
                        { category.map(({name, catID}) => (
                        <Option key={catID} value={catID}>{name}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
        </Row>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {t("common.cancel")}
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t("common.update")}
          </Button>
        </DrawerFooter>
      </Form> }
    </Drawer> 
  );
}
